import WhiteLabelConfigDev from './dev';
import WhiteLabelConfigProd from './prod';

const WhiteLabelConfig = process.env.REACT_APP_ENV === 'production' ? WhiteLabelConfigProd : WhiteLabelConfigDev;
export default WhiteLabelConfig;
